import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {t} from "i18next";
import moment from "moment";

import {deleteReq, fetchData, fetchDataNew, fetchList, fetchListNew} from "../../hook/axios.hook";
import {toaster} from "../../utilities/hooks/toaster";
import {toggleFreezeCOf} from "../KP/kp-f/KpFinSlice";

const initialState = {
  projects: [],
  projectsIdList: [],
  currentProjectManager: null,
  currentProject: null,
  statusList: [],
  projectsLoadingStatus: false,
  docsLoading: false,
  editedProject: null,
  contracts: null,
  filters: null,
  coFilters: null,
  allCOs: [],
  currentCO: null,
  annexes: [],
  einfo: [],
  currentProjectDocument: null,
  projectDocumentsLoading: false,
  allTodos: [],
  currentTodo: null,
  toDoLoadingStatus: false,
  deliveryTerms: [],
  kpLoadingStatus: false,
};

export const fetchProjects = createAsyncThunk("projects/fetchProjects", async () => {
  const responce = fetchListNew("/projects/getForCurrent", "get");
  return responce;
});

export const fetchProjectsWithFilter = createAsyncThunk(
  "projects/fetchProjectsWithFilter",
  async ({signal, ...params} = {}, {rejectWithValue}) => {
    const responce = fetchDataNew(`/projects/getAll`, "get", {params, rejectWithValue, signal});
    return responce;
  },
);

export const fetchProjectById = createAsyncThunk("projects/fetchProjectById", async projectId => {
  const responce = fetchDataNew(`/projects/get/${projectId}`, "get");
  return responce;
});

export const fetchProjectByUserId = createAsyncThunk("projects/fetchProjectByUserId", async userId => {
  const responce = fetchData(`/projects/getForUser/${userId}`, "get");
  return responce;
});

export const addProject = createAsyncThunk("projects/addProject", async ({clientId, countryId}) => {
  const responce = fetchDataNew(`/projects/add/${clientId}/${countryId}`, "post", {noMessage: true});
  return responce;
});

export const deleteProject = createAsyncThunk("projects/deleteProject", async projectId => {
  return fetchData(`/projects/remove/${projectId}`, "delete");
});

export const updateProject = createAsyncThunk("projects/updateProject", async ({projectId, data}) => {
  const responce = fetchDataNew(`/projects/update/${projectId}`, "patch", {rawBody: data, noMessage: true});
  return responce;
});

export const updateProjectStatus = createAsyncThunk("projects/updateProjectStatus", async ({projectId, statusId}) => {
  const responce = await fetchData(`/projects/update/${projectId} `, "patch", {
    statusId,
  });
  return responce;
});

export const getProjectStatuses = createAsyncThunk("projects/getStatusList", async () => {
  const responce = fetchData(`/references/projectsStatuses`, "get");
  // const responce = fetchData(`/references/forSku`, "get");

  return responce;
});

////////contract

export const fetchProjectContracts = createAsyncThunk("projects/fetchProjectContracts", async params => {
  return fetchListNew(`/contracts/getAll/`, "get", {params});
});

export const addProjectContract = createAsyncThunk("projects/addProjectContract", async projectId => {
  const responce = fetchListNew(`/contracts/add/${projectId}`, "post", {noMessage: true});
  return responce;
});

export const addProjectContractFile = createAsyncThunk(
  "projects/addProjectContractFile",
  async ({contractId, formdata}) => {
    return fetchDataNew(`/contracts/files/upload/${contractId}`, "post", {body: formdata, noMessage: true});
  },
);

export const delProjectContractFile = createAsyncThunk("projects/delProjectContractFile", async fileId => {
  const responce = deleteReq(`/contracts/files/remove/${fileId}`, null, null, true);
  return responce;
});

export const updateProjectContract = createAsyncThunk("projects/updateProjectContract", async ({contractId, data}) => {
  const responce = fetchDataNew(`/contracts/update/${contractId}`, "patch", {body: data, noMessage: true});
  return responce;
});

export const delProjectContract = createAsyncThunk("projects/delProjectContract", async contractId => {
  const responce = deleteReq(`/contracts/remove/${contractId}`);
  return responce;
});

////////einfo
export const fetchProjectEinfos = createAsyncThunk("projects/fetchProjectEinfos", async params => {
  return fetchDataNew(`/einfo/getAll/`, "get", {params});
});
export const addEinfo = createAsyncThunk("projects/addEinfo", async projectId => {
  const responce = fetchDataNew(`/einfo/add/${projectId}`, "post", {noMessage: true});
  return responce;
});
export const updateEinfo = createAsyncThunk("projects/updateEinfo", async ({einfoId, data}) => {
  const responce = fetchDataNew(`/einfo/update/${einfoId}`, "patch", {body: data, noMessage: true});
  return responce;
});
export const addEinfoFile = createAsyncThunk("projects/addEinfoFile", async ({einfoId, formdata}) => {
  const responce = fetchDataNew(`/einfo/files/upload/${einfoId}`, "post", {body: formdata, noMessage: true});
  return responce;
});
export const delEinfoFile = createAsyncThunk("projects/delEinfoFile", async fileId => {
  const responce = deleteReq(`/einfo/files/remove/${fileId}`, null, null, true);
  return responce;
});
export const delEinfo = createAsyncThunk("projects/delEinfo", async einfoId => {
  return deleteReq(`/einfo/remove/${einfoId}`);
});

export const fetchProjectFilters = createAsyncThunk("projects/fetchFilters", async () => {
  return fetchData(`/projects/getFilters`, "get");
});

//*** COs ***/
export const getCoFilters = createAsyncThunk("project/getCoFilters", async (params, {rejectWithValue}) =>
  fetchListNew("cos/getFilters", "get", {params, rejectWithValue}),
);
export const fetchAllCOs = createAsyncThunk("projects/fetchAllCOs", async (params, {rejectWithValue}) =>
  fetchListNew("/cos/getAll", "get", {params, rejectWithValue}),
);
export const fetchCO = createAsyncThunk("projects/fetchCO", async ({coId}) => fetchData(`/cos/get/${coId}`, "get"));
export const addCO = createAsyncThunk("projects/addCO", async ({projectId, body}) =>
  fetchDataNew(`/cos/add/${projectId}`, "post", {body, noMessage: true}),
);
export const updateCO = createAsyncThunk("projects/updateCO", async ({coId, body}) =>
  fetchData(`/cos/update/${coId}`, "patch", body),
);
export const deleteCO = createAsyncThunk("projects/delCO", async ({coId}, {rejectWithValue}) =>
  fetchDataNew(`/cos/remove/${coId}`, "delete", {rejectWithValue, noMessage: true}),
);

//*** TODO */
export const fetchAllTodos = createAsyncThunk("projects/fetchAllTodos", async ({projectId, coId}, {rejectWithValue}) =>
  fetchListNew("/todo/getAll", "get", {params: {projectId, coId}, rejectWithValue}),
);
export const fetchTodo = createAsyncThunk("projects/fetchTodo", async ({todoId}) =>
  fetchList(`/todo/get/${todoId}`, "get"),
);
export const addTodo = createAsyncThunk("projects/addTodo", async ({projectId, coId, body}) =>
  fetchData(`/todo/add`, "post", body, null, false, {projectId, coId}, true),
);
export const updateTodo = createAsyncThunk("projects/updateTodo", async ({todoId, body}) =>
  fetchData(`/todo/update/${todoId}`, "patch", body, null, false, null, true),
);
export const deleteTodo = createAsyncThunk("projects/deleteTodo", async ({todoId}) =>
  fetchData(`/todo/remove/${todoId}`, "delete"),
);

//*** Delivery terms */
export const fetchAllDeliveryTerms = createAsyncThunk("projects/fetchAllDeliveryTerms", async () =>
  fetchList("/projects/deliveryTerms/getAll", "get"),
);

/////annex
export const addAnnex = createAsyncThunk("projects/addAnnex", async ({coId}) => {
  return fetchDataNew(`/annexes/add/${coId}`, "post", {noMessage: true});
});

export const deleteAnnex = createAsyncThunk("projects/deleteAnnex", async (data, {rejectWithValue}) => {
  const annexId = typeof data === "object" ? data?.annexId : data;
  const withoutError = typeof data === "object" ? data?.withoutError : undefined;

  return fetchDataNew(`/annexes/remove/${annexId}`, "delete", {rejectWithValue, withoutError});
});

export const fetchAnnexes = createAsyncThunk("projects/fetchAnnexes", async params => {
  return fetchDataNew(`/annexes/getAll`, "get", {params});
});

export const getAnnexInfo = createAsyncThunk("projects/getAnnexInfo", async annexId => {
  return fetchData(`/annexes/get/${annexId}`, "get");
});

export const updateAnnex = createAsyncThunk("projects/updateAnnex", async ({annexId, data}) => {
  return fetchDataNew(`/annexes/update/${annexId}`, "patch", {body: data, noMessage: true});
});

// export const preCreateDirective = createAsyncThunk("finSettings/preCreateDirective", async ({cofId}) => {
//   return fetchData(`/finance/directives/preCreate/${cofId}`, "post");
// });

const projectSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    annexesFetched: () => {
      // state.filteredAnnexes = action.payload
    },
    setEditedProject: (state, action) => {
      state.editedProject = action.payload;
    },
    deselectProject: state => {
      state.currentProject = null;
      state.contracts = [];
      // state.annexes = [];
      state.einfo = [];
    },
    setCurrentProjectManager: (state, action) => {
      state.currentProjectManager = action.payload;
    },
    setCurrentProjectDocument: (state, action) => {
      state.currentProjectDocument = action.payload;
    },
    clearCurrentCO: state => {
      state.currentCO = null;
    },
    clearCurrentTodo: state => {
      state.currentTodo = null;
    },
    clearCOs: state => {
      state.allCOs = [];
    },
    clearTodos: state => {
      state.allTodos = [];
    },
    clearDeliveryTerms: state => {
      state.deliveryTerms = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchProjects.pending, state => {
        state.projectsLoadingStatus = true;
      })
      .addCase(fetchProjects.fulfilled, (state, action) => {
        state.projectsLoadingStatus = false;
        state.projects = action.payload;
        // .map((project)=>{
        //     var proj ={};
        //     for(var key in project){
        //         proj[key] = project[key] || ''
        //     }
        //     return proj
        // });
        state.projectsIdList = action.payload.map(project => {
          return {number: project.projectNumber, id: project.projectId};
        });
      })
      .addCase(fetchProjectsWithFilter.pending, state => {
        state.projectsLoadingStatus = true;
      })
      .addCase(fetchProjectsWithFilter.fulfilled, (state, action) => {
        state.projectsLoadingStatus = false;
        state.projects = action.payload;
      })
      .addCase(fetchProjectByUserId.pending, state => {
        state.projectsLoadingStatus = true;
      })
      .addCase(fetchProjectByUserId.fulfilled, (state, action) => {
        state.projectsLoadingStatus = false;
        state.projects = action.payload;
        state.projectsIdList = action.payload.map(project => {
          return {number: project.projectNumber, id: project.projectId};
        });
      })
      .addCase(fetchProjectById.pending, state => {
        state.projectsLoadingStatus = true;
      })
      .addCase(fetchProjectById.fulfilled, (state, action) => {
        state.currentProject = action.payload;
        state.projectsLoadingStatus = false;
        // var proj = {};
        // for (var key in action.payload.project) {
        //   proj[key] = action.payload.project[key] || "";
        // }

        // state.currentProject = {
        //   ...proj,
        //   userId: proj?.projectManager?.userId,
        //   userName: proj?.projectManager?.name,
        //   designerBonus: proj?.designer?.bonus || "",
        //   designerId: proj?.designer.designerId,
        //   designerName: proj?.designer.name,
        //   orgName: proj.orgStructure.shortName,
        //   orgStructureId: proj.orgStructure.orgStructureId,
        // };
        // var myproj = state.projects.find(project => project.projectKey === proj.projectKey);
        // if (!myproj) {
        //   state.projects.unshift(proj);
        // }
        // state.contracts = action.payload.project?.contracts;

        // state.annexes = [].concat(...action.payload.project.cos.map(co => co.annexes));

        // state.einfo = action.payload.project.einfo;
      })
      .addCase(addProject.fulfilled, (state, {payload}) => {
        if (!payload) return;
        // state.projects.unshift(payload.project);
        state.currentProject = {
          ...payload.project,
          cos: Array.isArray(payload?.project?.cos) ? payload.project.cos : [],
        };
      })
      .addCase(updateProject.fulfilled, (state, {payload}) => {
        if (!payload) return;

        const {project} = payload;
        state.currentProject = {...(state.currentProject ?? {}), ...project};
        state.projects = state.projects.map(item => {
          if (item.projectId === project.projectId) {
            return {...item, ...project};
          } else return item;
        });
      })
      .addCase(addProject.rejected, (state, {error}) => {
        toaster.error(error?.message || String(error));
      })
      .addCase(deleteProject.fulfilled, state => {
        // state.projects.unshift(payload.project);
        state.currentProject = null;
        toaster.success(t("project deleted"));
      })
      .addCase(updateProjectStatus.fulfilled, (state, {payload}) => {
        if (!payload) return;

        const updatedProject = payload.project;
        state.currentProject = {
          ...state.currentProject,
          ...updatedProject,
        };
      })
      .addCase(getProjectStatuses.fulfilled, (state, {payload}) => {
        state.statusList = payload;
      })
      ////contracts
      .addCase(fetchProjectContracts.pending, state => {
        state.projectDocumentsLoading = true;
      })
      .addCase(fetchProjectContracts.fulfilled, (state, {payload}) => {
        state.contracts = payload || [];
        state.projectDocumentsLoading = false;
      })
      .addCase(addProjectContract.fulfilled, (state, {payload}) => {
        if (!payload) return;

        (state.contracts || []).push({
          ...payload.contract,
          deadline: moment().format("YYYY-MM-DD"),
          // contractDeadline: dateFormat(payload.contract.contractDeadline),
        });
      })
      .addCase(updateProjectContract.fulfilled, (state, {payload}) => {
        if (!payload) return;

        const {contract} = payload;
        state.contracts = (state.contracts || []).map(item => {
          if (item.contractId === contract.contractId) {
            return {
              ...item,
              ...contract,
              contractDeadline: contract.contractDeadline,
            };
          } else return item;
        });
        state.projects = (state.projects || []).map(project => {
          if (project.projectId === state.currentProject.projectId) {
            return {...project, deadline: payload.contract?.deadline};
          } else return project;
        });
      })
      .addCase(addProjectContractFile.pending, state => {
        state.docsLoading = true;
      })
      .addCase(addProjectContractFile.fulfilled, state => {
        // const {payload, meta} = action;
        // state.contracts = state.contracts.map(contract => {
        //   if (contract.contractId === meta.arg.contractId) {
        //     return {...contract, docsArray: payload.docsArray};
        //   } else {
        //     return contract;
        //   }
        // });
        state.docsLoading = false;
      })
      .addCase(delProjectContractFile.fulfilled, () => {
        // const {payload, meta} = action;
        // state.contracts = state.contracts.map(contract => {
        //   if (contract.contractId === meta.arg.contractId) {
        //     return {...contract, docsArray: payload.docsArray};
        //   } else {
        //     return contract;
        //   }
        // });
      })
      .addCase(delProjectContract.fulfilled, (state, action) => {
        const {meta} = action;
        state.contracts = state.contracts.filter(contract => contract.contractId !== meta.arg);
      })

      // Einfo
      .addCase(fetchProjectEinfos.pending, state => {
        state.projectDocumentsLoading = true;
      })
      .addCase(fetchProjectEinfos.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.einfo = payload || [];
        state.projectDocumentsLoading = false;
      })
      .addCase(addEinfo.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.einfo.unshift({
          ...payload.einfo,
          dateFrom: payload.einfo.dateFrom,
        });
      })
      .addCase(updateEinfo.fulfilled, (state, {payload}) => {
        if (!payload) return;

        const {einfo} = payload;
        state.einfo = (state.einfo || []).map(item => {
          if (item.einfoId === einfo.einfoId) {
            return {...item, ...einfo, dateFrom: einfo.dateFrom};
          } else return item;
        });
      })
      .addCase(addEinfoFile.pending, state => {
        state.docsLoading = true;
      })
      .addCase(addEinfoFile.fulfilled, (state, action) => {
        const {payload, meta} = action;
        if (!payload) return;

        state.einfo = (state.einfo || []).map(ein => {
          if (ein.einfoId === meta.arg.einfoId) {
            return {...ein, docsArray: payload.docsArray};
          } else {
            return ein;
          }
        });
        state.docsLoading = false;
      })
      // .addCase(delEinfo.fulfilled, (state, action) => {
      //   const {payload, meta} = action;
      //   state.einfo = state.einfo.map(einfo => {
      //     if (einfo.einfoId === meta.arg.einfoId) {
      //       return {...einfo, docsArray: payload.docsArray};
      //     } else {
      //       return einfo;
      //     }
      //   });
      // })
      .addCase(delEinfo.fulfilled, (state, action) => {
        const {meta} = action;
        state.einfo = (state.einfo || []).filter(einfo => einfo.einfoId !== meta.arg);
      })
      .addCase(fetchProjectFilters.pending, state => {
        state.projectsLoadingStatus = true;
      })
      .addCase(fetchProjectFilters.fulfilled, (state, {payload}) => {
        state.projectsLoadingStatus = false;
        state.filters = payload;
      })

      //*** COs ***/
      .addCase(fetchAllCOs.pending, state => {
        state.kpLoadingStatus = true;
      })
      .addCase(fetchAllCOs.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.kpLoadingStatus = false;
          return;
        }
        state.kpLoadingStatus = false;
        state.allCOs = payload?.currentPage > 1 ? [...state.allCOs, ...payload.data] : payload.data;
      })
      .addCase(getCoFilters.pending, state => {
        state.kpLoadingStatus = true;
      })
      .addCase(getCoFilters.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.kpLoadingStatus = false;
          return;
        }
        state.kpLoadingStatus = false;
        state.coFilters = payload;
      })
      .addCase(fetchCO.fulfilled, (state, {payload}) => {
        state.currentCO = payload;
      })
      .addCase(addCO.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.currentCO = payload.co;

        if (Array.isArray(state.currentProject?.cos) && payload?.co) {
          const exists = state.currentProject.cos.some(({coId}) => coId === payload.co.coId);
          if (!exists) {
            state.currentProject.cos.push(payload.co);
          }
        }
      })
      .addCase(updateCO.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.currentCO = {...state.currentCO, ...payload.co};
      })
      .addCase(deleteCO.fulfilled, (state, action) => {
        state.currentCO = null;

        const deletedCoId = action.meta?.arg?.coId;

        if (deletedCoId && Array.isArray(state.currentProject?.cos)) {
          state.currentProject.cos = state.currentProject.cos.filter(({coId}) => coId !== deletedCoId);
        }
      })

      // .addCase(preCreateDirective.fulfilled, (state, {payload}) => {
      //   state.currentCO = payload.co;
      // })

      //// Annexes
      .addCase(addAnnex.fulfilled, (state, {payload}) => {
        const annex = payload?.annex;
        if (annex && state.currentCO?.coId === annex.coId) {
          state.currentCO.annexes = [...(state.currentCO.annexes ?? []), annex];
        }
      })
      .addCase(fetchAnnexes.pending, state => {
        state.projectDocumentsLoading = true;
      })
      .addCase(fetchAnnexes.fulfilled, (state, action) => {
        const {payload} = action;
        state.annexes = payload;
        state.projectDocumentsLoading = false;
      })
      .addCase(updateAnnex.fulfilled, (state, action) => {
        const {payload, meta} = action;
        const newAnex = payload?.annex;
        if (!payload || !newAnex) return;
        state.annexes = state.annexes.map(annex => {
          if (annex.annexId === meta.arg.annexId) {
            return {...annex, ...newAnex};
          }
          return annex;
        });
      })

      .addCase(deleteAnnex.fulfilled, (state, action) => {
        const {meta} = action;
        state.annexes = state.annexes.filter(annexe => annexe.annexId !== meta.arg.annexId);
        if (state.currentCO?.annexes) {
          state.currentCO.annexes = state.currentCO.annexes.filter(annex => annex.annexId !== meta.arg.annexId);
        }
      })

      .addCase(toggleFreezeCOf.fulfilled, (state, {payload}) => {
        state.allCOs = (state.allCOs || []).map(co => {
          if (co?.coId === payload?.coId) {
            return {
              ...co,
              cofs: co?.cofs?.map(cof => {
                if (cof?.cofId === payload?.cofId) {
                  return {...cof, freezedForClient: payload?.freezedForClient, freezedInfo: payload?.freezedInfo};
                }
                return cof;
              }),
            };
          }

          return co;
        });
      })

      //*** TODO */
      .addCase(fetchAllTodos.pending, state => {
        state.toDoLoadingStatus = true;
      })
      .addCase(fetchAllTodos.fulfilled, (state, {payload}) => {
        state.toDoLoadingStatus = false;
        state.allTodos = payload;
      })
      .addCase(fetchTodo.fulfilled, (state, {payload}) => {
        state.currentTodo = payload;
      })
      .addCase(addTodo.fulfilled, (state, {payload}) => {
        state.currentTodo = payload.todo;
      })
      .addCase(updateTodo.fulfilled, (state, {payload}) => {
        state.currentTodo = payload.todo;
      })
      .addCase(deleteTodo.fulfilled, state => {
        state.currentTodo = null;
      })

      //*** Delivery terms */
      .addCase(fetchAllDeliveryTerms.fulfilled, (state, {payload}) => {
        state.deliveryTerms = payload;
      })

      .addDefaultCase(() => {});
  },
});

const {actions, reducer} = projectSlice;

export default reducer;
export const {
  selectProject,
  setEditedProject,
  deselectProject,
  annexesFetched,
  setCurrentProjectManager,
  setCurrentProjectDocument,
  clearCurrentCO,
  clearCOs,
  clearCurrentTodo,
  clearTodos,
  clearDeliveryTerms,
} = actions;

// export const filteredAnnexSelector = createSelector(
//   state => state.projects.annexes,
//   state => state.kp.currentKp,
//   (annexes, currentKp) => {
//     if (!currentKp) {
//       return annexes;
//     } else {
//       return annexes.filter(item => item.coId === currentKp.coId);
//     }
//   },
// );

export const getProjectContracts = state => state.projects.contracts;
export const getCurrentProject = state => state.projects.currentProject;
export const getProjects = state => state.projects.projects;
// export const getProjectAnnexes = state => state.projects.annexes;
export const getProjectEinfo = state => state.projects.einfo;
export const getDocsLoading = state => state.projects.docsLoading;
export const getProjectStatus = state => state.projects.statusList;
export const getCurrentProjectManager = state => state.projects.currentProjectManager;
export const getProjectFilters = state => state.projects.filters;
export const getProjectDocument = state => state.projects.currentProjectDocument;
export const selectAllCOs = state => state.projects.allCOs;
export const selectCurrentCO = state => state.projects.currentCO;
export const selectCoFilters = state => state.projects.coFilters;
export const selectAllTodos = state => state.projects.allTodos;
export const selectCurrentTodo = state => state.projects.currentTodo;
export const selectDeliveryTerms = state => state.projects.deliveryTerms;

export const getCoAnnexes = state => state.projects.annexes;
export const getProjectLoading = state => state.projects.projectsLoadingStatus;
export const getCOLoading = state => state.projects.kpLoadingStatus;
export const getToDoLoading = state => state.projects.toDoLoadingStatus;
export const getProjectDocumentLoading = state => state.projects.projectDocumentsLoading;
